import axios from 'axios'
import { baseUrl } from '../config'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import qs from 'qs'
import router from '../router'

const baseUrlApi = process.env.NODE_ENV === "production" ? "http://www.maisuiedu.com/api" : baseUrl
// const baseUrlApi = process.env.NODE_ENV === "production" ? "http://10.10.30.11:9002/api" : baseUrl
const service = axios.create({
  baseURL: baseUrlApi, 
  withCredentials: true,
  timeout: 30000, 
})

service.interceptors.request.use(
  config => {
    if (config.type == 'json') {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    }
    else {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
    }
    if (window.localStorage.getItem('Token')) {
      config.headers.Authorization = window.localStorage.getItem('Token')
    }
    if (config.data instanceof FormData) {
      config.params = {
        ...config.params
      }
      return config
    }
    if (config.method === 'post' && config.type != 'json') {
      let data = qs.parse(config.data)
      const finalData = {
        ...data
      }
      config.data = qs.stringify(finalData)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(

  response => {
    const res = response.data
    if (response.status === 200) {

      if (response.data.status === 100401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定退出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      if (response.data.status === 100403) { 
        Message.error(response.data.msg)
        return Promise.reject(new Error(res.message || 'Error'))
      }
      if (response.data.status && response.data.status !== 0) {
        Message.error(response.data.msg)
        return Promise.reject(new Error(res.message || 'Error'))
      }
      return response.data
    } else {
      Message.error(response.msg)
      return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  error => {
    Message({
      message: '请求服务器失败，请检查服务是否正常',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service


